export default function isInsideIframe() {
    return window.self !== window.top;
}
